import * as React from 'react';
import { CSVString2Array } from '../../../Utilities/Utilities';
import ListSelection from '../../Licences/ListSelection';
import TextField from '@mui/material/TextField';



const  ApplicationInformation = ({data, onFieldChange, applicationList}) => {    //  const [row, setRow] = useState(LicenceData);
    const max=100;
   const min = 0;

    const appNameList = applicationList.map((el) => {
        return el.name;
    });
    console.log("Templates: ", applicationList);

    return (
        <div style={{width:800}}>
          
           
            {applicationList !== undefined &&    
                <div style={{marginTop: "20px", marginLeft: "20px"}}>
                    <ListSelection 
                    baseList={appNameList} 
                    selectedList={CSVString2Array(data.applications).sort((a,b) => a > b ? 1 : -1)} 
                    title={"Organization Applications"} 
                    id = "applications" 
                    onSelectionChange={(event,value, id) => onFieldChange(value, id)} 
                    />
                </div>
            }
             <div style={{marginLeft:"20px", marginTop: "20px", width:200}}>
                <TextField
                    fullWidth
                    id="nbOfSeats" 
                    label="Number of Users" 
                    variant="outlined"
                    type="number"
                    className="TextField"
                    InputProps={{
                        inputProps: { 
                            max: {max}, min: {min} 
                        }
                    }}
                    value={data.nbOfSeats}
                    onChange={(event) => {
                        var value = parseInt(event.target.value, 10);
                        if (value > max) value = max;
                        if (value < min) value = min;
                        onFieldChange(value, event.target.id
                        )}}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </div>
           
        </div>
    );
   
}

export default ApplicationInformation;